import React from 'react';


export default class Store extends React.PureComponent {
    render() {
        return <div></div>;
    }
}
